<div class="container-fluid pt-4">
    <div class="container border-bottom-gris-01 pb-3 mb-3">
        <div class="row">
            <div class="col">
                <p class="mb-3">
                    <a [href]="'/home'" class="btn btn-xs shadow-none align-middle px-1 text-gris-02">
                        <img src="./assets/images/arrow-left-gris-01.svg" width="18px">
                        Volver
                    </a>
                </p>
                <h2 class="mb-2" [style.color]="primaryColor">Politica Integrada de Gestión</h2>
            </div>
            <!-- <div class="col-auto d-flex align-items-end">
                <button class="btn btn-secondary shadow-none rounded-pill mb-2" [style.color]="primaryColor">Descargar PDF</button>
            </div> -->
        </div>
    </div>
    <div class="container content">
        <h4 class="mb-3" [style.color]="primaryColor">SEPTIEMBRE 2023</h4>
        <p>Garibaldi es una empresa chilena de propiedad familiar, reconocida como líder en la fabricación y comercialización de productos y soluciones de final de línea. Así como también de insumos de acero de alta calidad como mangos y flejes.</p>
        <p>La seguridad e integridad de nuestro personal y otras partes interesadas, la calidad de nuestros productos y servicios, el conocimiento técnico y el prestigio alcanzados durante 70 años de trayectoria son los pilares de nuestra ventaja competitiva.</p>
        <p>Por ello, quienes laboramos en GARIBALDI S.A.:</p>
        <ul>
            <li>Velamos por la seguridad de todos quienes están en nuestras instalaciones, educándonos en el autocuidado, cuidándonos los unos a los otros, eliminando peligros y reduciendo riesgos.</li>
            <li>Hacemos todo cuanto esté a nuestro alcance para cumplir las expectativas y los compromisos asumidos con nuestros clientes y otras partes interesadas.</li>
            <li>Participamos y promovemos activamente la mejora permanente de todos nuestros procesos y productos.</li>
            <li>Nos comprometemos en promover la consulta y participación de los trabajadores en materia de seguridad y salud en el trabajo.</li>
            <li>Entendemos que proteger el medio ambiente y nuestra comunidad es esencial para el éxito de nuestra empresa, por lo que nos aseguramos de prevenir la contaminación.</li>
            <li>Cumplimos con los requisitos legales y otros requisitos.</li>
        </ul>
        <p>Para cumplir con nuestra política de gestión integrada, vigilaremos el cumplimiento de nuestros procesos y monitorearemos disciplinadamente los indicadores de gestión que nos permitan identificar e implementar las oportunidades de mejora que existan.</p>
        <br/>
        <br/>
        <p>Federico Torino A.</p>
        <p>Gerente General</p>
    </div>
</div>

<!--!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>Política Integrada de Gestión</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            margin: 20px;
            line-height: 1.6;
        }
        
        h1 {
            font-size: 24px;
            text-align: center;
        }
        
        p {
            text-align: justify;
            margin-bottom: 10px;
        }
        
        .signature {
            text-align: right;
            margin-top: 30px;
        }
    </style>
</head>
<body>
    <img width="40%" height="40%" src="assets/images/intro.png" alt="Logo de la aplicación" class="img-fluid mb-4 mx-auto d-block">
    <h1>Política Integrada de Gestión</h1>
    
    
    <div >
        
    </div>
</body>
</html-->
